<mat-card style="max-height: 500px">
  <mat-card-header>
    <mat-card-title>Exports as CSV</mat-card-title>
    <mat-card-subtitle class="py-1">Filters:</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="d-flex flex-column pt-2">
    <p>
      <span class="me-1">Start Date:</span> <span>{{ csvMinDate | date: 'dd MMM yyyy' }}</span>
    </p>
    <p>
      <span class="me-1">End Date:</span> <span>{{ csvMaxDate | date: 'dd MMM yyyy' }}</span>
    </p>
    @if (searchExpression) {
      <p>
        <span class="me-1">Search By:</span> <span>'{{ searchExpression }}'</span>
      </p>
    }
    @if (transactionStatusFilter) {
      <p>
        <span class="me-1">Transaction Filter:</span> <span>{{ transactionStatusFilter }}</span>
      </p>
    }

    @if (dateRangeError) {
      <div class="alert alert-danger">
        {{ dateRangeError }}
      </div>
    }
    @if (error$ | async; as error) {
      <div class="alert alert-danger">
        {{ error }}
      </div>
    }

    @if ((loading$ | async) === false) {
      <div mat-dialog-actions align="end">
        <button (click)="onDismiss()" color="default" mat-stroked-button data-test="tx-csv-reports-dismiss-button">
          Close
        </button>
        @if (!dateRangeError) {
          <button
            (click)="onConfirm()"
            color="primary"
            mat-raised-button
             data-test="tx-csv-reports-confirm-button">
            Download
          </button>
        }
      </div>
    }

    @if (loading$ | async) {
      <odin-loading-spinner
        [active]="true"
        [diameter]="40"
        [colour]="'primary'"
      ></odin-loading-spinner>
    }
  </mat-card-content>
</mat-card>
